import { getOrderStatus, getLogOfStatuses, getMainProduct } from "./products";

export function parseRequiredActions(rawActions = [], order = {}, includeResolved = false) {
  const orders = [order];
  const actions = orders.reduce((res, order) => {
    return [
      ...res,
      ...rawActions
        .filter(({ resolvedTimestamp }) => {
          if (includeResolved) {
            return true;
          }

          return !resolvedTimestamp;
        })
        .reduce((res, rawAction) => {
          const { type, typeName, id, productId, resolvedTimestamp } = rawAction || {};
          const product = order?.products?.find(({ id }) => id === productId);

          if (product) {
            const action = {
              id,
              type,
              product,
              order,
              title: typeName,
              link: `/orders/${order?.uid}/action/${id}`,
              timestamp: null,
              resolvedTimestamp,
            };

            return [...res, action];
          }

          return res;
        }, []),
    ];
  }, []);

  orders.forEach((order) => {
    const product = getMainProduct(order?.products);
    const status = getOrderStatus(order?.products);
    const logOfStatuses = getLogOfStatuses(order?.products);
    const timestamp = logOfStatuses?.find((logItem) => logItem?.status === status)?.timestamp || null;

    if (status === "AwaitingSpecimen") {
      actions.push({
        id: null,
        type: "AwaitingSpecimen",
        product,
        order,
        title: "Specimen Needed",
        link: `/orders/${order?.uid}/specimen`,
        timestamp,
        resolvedTimestamp: null,
      });
    }
  });

  return actions;
}
